export const state = Object.freeze({
    files: [],
    progress: [],
    uploadedUrls: [],
    uploading: false,
    error: null,
    isDragActive: false
});
